import SegmentDataModel from '@/common/models/segment-data-model';

import invoiceColumns from '@/common/definitions/columns/invoices';
import customerColumns from '@/common/definitions/columns/customers';
import transactionColumns from '@/common/definitions/columns/transactions';
import orderColumns from '@/common/definitions/columns/orders';
import apiLogColumns from '@/common/definitions/columns/api-logs';
import webhookLogsColumns from '@/common/definitions/columns/webhooks-logs';
import couponRedemptionColumns from '@/common/definitions/columns/coupons';

export default {
    [SegmentDataModel.Types.invoices]: invoiceColumns,
    [SegmentDataModel.Types.transactions]: transactionColumns,
    [SegmentDataModel.Types.orders]: orderColumns,
    [SegmentDataModel.Types.customers]: customerColumns,
    [SegmentDataModel.Types.apiLogs]: apiLogColumns,
    [SegmentDataModel.Types.webhookLogs]: webhookLogsColumns,
    [SegmentDataModel.Types.couponRedemptions]: couponRedemptionColumns,
};
